import React, { useEffect } from 'react'
import '../styles/FormStatusModal.css'
import { useTranslation } from '../context/LanguageContext.jsx'

const FormStatusModal = ({ status, onClose }) => {
  const { t } = useTranslation()

  useEffect(() => {
    if (!status) return undefined

    const onKeyDown = (e) => {
      if (e.key === 'Escape') onClose()
    }
    document.addEventListener('keydown', onKeyDown)
    const prevOverflow = document.body.style.overflow
    document.body.style.overflow = 'hidden'

    return () => {
      document.removeEventListener('keydown', onKeyDown)
      document.body.style.overflow = prevOverflow
    }
  }, [status, onClose])

  if (!status) return null

  const isSuccess = status === 'success'
  const title = isSuccess ? t('formStatus.successTitle') : t('formStatus.errorTitle')
  const message = isSuccess ? t('formStatus.successBody') : t('formStatus.errorBody')

  return (
    <div
      className="form-status-modal"
      role="dialog"
      aria-modal="true"
      aria-labelledby="form-status-title"
      aria-describedby="form-status-desc"
      onClick={onClose}
    >
      <div
        className={`form-status-modal-card form-status-modal-card--${status}`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="form-status-modal-icon" aria-hidden="true">
          {isSuccess ? (
            <svg viewBox="0 0 24 24" fill="none">
              <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.75" />
              <path
                d="M8 12.5l2.5 2.5L16 9.5"
                stroke="currentColor"
                strokeWidth="1.75"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          ) : (
            <svg viewBox="0 0 24 24" fill="none">
              <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.75" />
              <path
                d="M12 8v5M12 16.5h.01"
                stroke="currentColor"
                strokeWidth="1.75"
                strokeLinecap="round"
              />
            </svg>
          )}
        </div>
        <h3 id="form-status-title">{title}</h3>
        <p id="form-status-desc">{message}</p>
        <button type="button" className="form-status-modal-btn" onClick={onClose}>
          {t('formStatus.close')}
        </button>
      </div>
    </div>
  )
}

export default FormStatusModal
